export default __webpack_public_path__ + "static/logo-6589b7935c5867c958cca5018e1546f4.svg";